// extracted by mini-css-extract-plugin
module.exports = {"mentionSuggestions":"mentionSuggestions-EDOMD","show_delay":"show_delay-pFg6t","group":"group-ybhIE"};